import React from 'react';
const { Provider: NetworkStatusProvider, Consumer: NetworkStatusConsumer } = React.createContext(undefined);
export { NetworkStatusConsumer, NetworkStatusProvider };
//# sourceMappingURL=NetworkStatusContext.js.map